import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import PublicRoute from "./components/PublicRoute";
import ProtectedRoute from "./components/ProtectedsRoute";

import Customers from "./pages/Customers";
import Invoices from "./pages/Invoices";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import HelpSupport from "./pages/HelpSupport";
import Layout from "./components/shared/Layout";
import InvoicePrint from "./components/invoice/printto/InvoicePrint";
import UserProfile from "./components/UserProfile";
import ChangePassword from "./components/ChangePassword";

import AllItems from "./pages/AllItems";
import Salesteam from "./pages/SalesTeam";
import Mail from "./pages/Mail";
import FailedEmailLogs from "./pages/FailedEmailLogs";
import CampaignStatus from "./pages/CampaignStatus";
import Signatures from "./pages/Signatures";
import Propsoal from "./pages/Propsoal"; 
import RateCard from "./pages/RateCard";
import PhotoMaker from "./pages/PhotoMaker";  

import { InvoiceView } from "./components/invoice/InvoiceView";
import Vendors from "./pages/vendors";
import PurchaseOrders from "./pages/PurchaseOrders";
import { InvoiceGenerateWithoutpo } from "./pages/InvoiceGenerateWithoutpo";
import { DataVisual } from "./pages/DataVisual";
import DeliveryNoteApproval from "./pages/DeliveryNoteApproval";
import DeliveryChallanPrint from "./components/delivery/DeliveryChallanPrint";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <BrowserRouter>
      <>
        <ToastContainer position="top-right" autoClose={3000} />

        <Routes>
          <Route
            path="/login"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />

          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="transactions" element={<Dashboard />} />
            <Route path="purchase-orders" element={<PurchaseOrders />} />
            <Route path="customers" element={<Customers />} />
            <Route path="vendors" element={<Vendors />} />
            <Route path="sales" element={<Salesteam />} />

            <Route path="campaign-status" element={<CampaignStatus />} />
            <Route path="campaign-status/:token" element={<CampaignStatus />} />

            <Route path="mail" element={<Mail />} />
            <Route path="mail/service-types" element={<Mail section="service-types" />} />
            <Route path="mail/services" element={<Mail section="services" />} />
            <Route path="mail/templates" element={<Mail section="templates" />} />
            <Route path="mail/failed" element={<FailedEmailLogs />} />

            <Route path="signatures" element={<Signatures />} />

            {/* ✅ MATCHING COMPONENT NAME */}
            <Route path="propsoal" element={<Propsoal />} />
            <Route path="RateCard" element={<RateCard />} />
            <Route path="PhotoMaker" element={<PhotoMaker />} />

            <Route path="help" element={<HelpSupport />} />
            <Route path="profile" element={<UserProfile />} />
            <Route path="changepass" element={<ChangePassword />} />

            <Route path="invoices" element={<Invoices />} />
            <Route path="InvoiceView" element={<InvoiceView />} />
            <Route path="InvoicePrint/:id" element={<InvoicePrint />} />
            <Route path="withoutpogenerates" element={<InvoiceGenerateWithoutpo />} />

            <Route path="delivery-note-approval/:id" element={<DeliveryNoteApproval />} />
            <Route path="delivery-challan/print/:id" element={<DeliveryChallanPrint />} />

            <Route path="all-items" element={<AllItems />} />
            <Route path="analytics" element={<DataVisual />} />
          </Route>
        </Routes>
      </>
    </BrowserRouter>
  );
}

export default App;